import React from 'react';
import Chip from '@pezeshk-book/ui-kit/chip';
import EyeIcon from '@icons-components/eye-icon';

const PostHits = ({ hits }: { hits: any }) => {
  return (
    <Chip
      color={'tertiary'}
      startAdornment={<EyeIcon/>}
      value={`تعداد بازدید: ${hits}`}/>
  );
};

export default PostHits;
